import React, { type PropsWithChildren } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { HStack, LabelText, theme, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const PartnerLineItemNutrition = (props: Props) => {
  const { children, withBorder = false } = props;

  const { match } = useResponsive();

  // ─── Styles ────────────────────────────────────────────────────────────────

  const separatorStyles = withBorder ? match([undefined, styles.separatorSM]) : undefined;
  const containerStyles = [
    styles.container,
    match([styles.containerXS, styles.containerSM]),
    separatorStyles,
  ];

  const gap = match([theme.spacing['10'], theme.spacing['16']]);

  // ───────────────────────────────────────────────────────────────────────────

  return (
    <View style={containerStyles}>
      <LabelText bold sizeMatch={['12', '14']} style={styles.title}>
        <FormattedMessage {...messages.title} />
      </LabelText>

      <HStack gap={gap} itemsPerRow={2} style={styles.stack}>
        {children}
      </HStack>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    alignSelf: 'stretch',
    flexGrow: 1,
  },
  containerXS: {
    gap: theme.spacing['6'],
    paddingVertical: theme.spacing['9'],
  },
  containerSM: {
    gap: theme.spacing['4'],
    paddingRight: theme.spacing['10'],
  },
  separatorSM: {
    borderColor: theme.colors.LIGHT,
    borderRightWidth: 1,
  },
  stack: {
    maxWidth: 400,
    rowGap: theme.spacing['4'],
  },
  title: {
    color: theme.colors.BROWN,
  },
});

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  title: {
    defaultMessage: 'Macros',
    description: 'Partner line item | Macros heading',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  withBorder?: boolean;
}>;
